module.exports = __webpack_public_path__ + "static/media/octopus.c2ce50e3.png";